import React from 'react';
import styles from '../../../assets/css/layoutMain/searchProviders/searchProviders.module.css';
import Button from '../../../components/button/Button';
import images from '../../../assets/images';

const SearchProviders = () => {
    return (
        <div className={styles.cardSearchProviders}>
            <div className={styles.inputSearch}>
                <label htmlFor="search">Search Providers</label>
                <input autoComplete="off" id="search" type="text" />
                <img src={images.search2} alt="icon" />
            </div>

            <div className={styles.gridContainer}>
                <Button classs="btnOutlineMain" text="Categories" />
                <Button classs="btnOutlineMain" text="Region Served" />
                <Button classs="btnOutlineMain" text="Markets" />
                <Button classs="btnOutlineMain" text="Language" />
                <Button classs="btnOutlineMain" text="Solutions" />
            </div>
        </div>
    );
};

export default SearchProviders;
